import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { authFetch } from './api';

import { ThemeProvider } from './context/ThemeContext';
import { SessionProvider } from './context/SessionContext';
import { GoalsProvider } from './context/GoalsContext';
import { FitnessProvider } from './context/FitnessContext';
import { GamificationProvider } from './context/GamificationContext';

import Layout from './components/layout/Layout';
import RoverIntegration from './components/RoverIntegration';
import Dashboard from './pages/Dashboard';
import SessionLog from './pages/SessionLog';
import Sessions from './pages/Sessions';
import SessionEdit from './pages/SessionEdit';
import Goals from './pages/Goals';
import TechniqueLibrary from './pages/TechniqueLibrary';
import TechniqueDetail from './pages/TechniqueDetail';
import TechniqueEdit from './pages/TechniqueEdit';
import Tournaments from './pages/Tournaments';
import Analytics from './pages/Analytics';
import WeeklySummary from './pages/WeeklySummary';
import Hydration from './pages/Hydration';
import Settings from './pages/Settings';
import Achievements from './pages/Achievements';
import Auth from './pages/Auth';
import Landing from './pages/Landing';

function App() {
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const res = await authFetch('get-session');
      if (res?.data?.user) {
        localStorage.setItem('user_id', res.data.user.id);
        setUserId(res.data.user.id);
      } else {
        localStorage.removeItem('user_id');
        setUserId(null);
      }
      setLoading(false);
    };
    checkSession();
  }, []);

  if (loading) {
    return <div className="flex h-screen items-center justify-center bg-slate-50 dark:bg-slate-900 text-slate-600 dark:text-slate-300">Loading...</div>;
  }

  return (
    <ThemeProvider>
      <Router>
        {!userId ? (
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth onLogin={setUserId} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        ) : (
          <SessionProvider>
            <GoalsProvider>
              <FitnessProvider>
                <GamificationProvider>
                  {/* Rover is now only loaded inside the authenticated context */}
                  <RoverIntegration />
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/session" element={<SessionLog />} />
                      <Route path="/sessions" element={<Sessions />} />
                      <Route path="/sessions/:id/edit" element={<SessionEdit />} />
                      <Route path="/goals" element={<Goals />} />
                      <Route path="/techniques" element={<TechniqueLibrary />} />
                      <Route path="/techniques/:id" element={<TechniqueDetail />} />
                      <Route path="/techniques/:id/edit" element={<TechniqueEdit />} />
                      <Route path="/tournaments" element={<Tournaments />} />
                      <Route path="/analytics" element={<Analytics />} />
                      <Route path="/weekly-summary" element={<WeeklySummary />} />
                      <Route path="/achievements" element={<Achievements />} />
                      <Route path="/hydration" element={<Hydration />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                  </Layout>
                </GamificationProvider>
              </FitnessProvider>
            </GoalsProvider>
          </SessionProvider>
        )}
      </Router>
    </ThemeProvider>
  );
}

export default App;